import moment from 'moment';
import 'moment/locale/ru';
import CheckInDateRangeFactory from '@/js/common/Domain/Factory/CheckInDateRange';

import checkFlexibleDay from './checkFlexibleDay';

export default function expandRequestCriteriaDates(tourCriteria) {
    if (!(tourCriteria && tourCriteria instanceof Backbone.Model)) throw new Error('tourcriteria is invalid');
    const expandedCriteria = tourCriteria.clone();
    const checkInDateRange = tourCriteria.get('checkInDateRange');

    if (!checkInDateRange) throw new Error('checkInDateRange required');

    const checkInDateRangeFrom = checkInDateRange.get('from');
    const checkInDateRangeTo = checkInDateRange.get('from');

    if (checkInDateRangeFrom && checkInDateRangeTo && moment(checkInDateRangeFrom).isSame(checkInDateRange.get('to'))) {
        const daysFlexible = 1;
        const daysDiff = checkFlexibleDay({
            checkInDateRangeFrom,
            daysFlexible,
        });

        expandedCriteria.set('checkInDateRange', new CheckInDateRangeFactory({
            from: moment(checkInDateRangeFrom).subtract(daysFlexible - daysDiff, 'days').toDate(),
            to: moment(checkInDateRangeFrom).add(daysFlexible + daysDiff, 'days').toDate(),
        }));
    }

    return expandedCriteria;
}